import React from "react";

const Education = ({ detail }) => {
  return (
    <div className="card shadow border-0 rounded-4 overflow-hidden mb-5">
      <div className="card-body bg-gradient-secondary-to-primary p-3">
        <div className="bg-light rounded-4 p-4">
          <div className="text-primary fw-bolder text-primary mb-2">
            {detail[0]}
          </div>

          <div className="fw-bold fs-5 text-gradient mb-2">{detail[3]}</div>

          <div className="text-muted">{detail[1]}</div>

          <div className="text-muted">({detail[4]})</div>

          <div className="fst-italic text-muted mt-3">{detail[2]}</div>
        </div>
      </div>
    </div>
  );
};

export default Education;
